/* eslint-disable react-hooks/rules-of-hooks */
import { WidgetUrlBehavior } from "@xapp/stentor-chat-widget";
import { useCallback } from "react";
import { scheduleWidgetUrl, useWidgetEnv } from "../config";
import { defaultBehavior, resolveUrlPolicy } from "../utils/resolveUrlPolicy";
import { throwBadKind } from "../utils/throwBadKind";
import { VisualState } from "../store/ChatState";
import setVisualStatus from "../store/actions/setVisualStatus";
import { ChatDispatch } from "../store/actions/types";
import { err } from "../utils";

export type OpenUrlCallback = (url: string, dispatch: ChatDispatch, visuals: VisualState, behavior?: WidgetUrlBehavior) => void;

function execute(url: string, dispatch: ChatDispatch, visuals: VisualState, behavior: WidgetUrlBehavior) {
    if (!dispatch || !visuals) {
        throw new Error(`OpenUrl: No dispatch and/or visual.`);
    }

    if (url === scheduleWidgetUrl) {
        // It's actually toggle
        const toggleForm = (window as any).xafwControl?.openForm;

        if (!toggleForm) {
            err("Cannot find toggleForm! Update form widget!");
            return;
        }

        let isFormActive = false;
        
        const formStatus = (window as any).xafwControl?.formStatus;
        if (formStatus) {
            const formVisuals = formStatus();
            isFormActive = formVisuals.active;
        } else {
            err("Cannot find formStatus! Update form widget!");
        }

        // If form is active and we are here, then both widgets are active. Do nothing. Let the user X out the widgets.

        if (!isFormActive) {
            toggleForm();
        
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            } 
        }    

        return;
    }

    // Attempt to add query string to the url
    // if the query string already exists, it will not be added
    try {
        const urlObj = new URL(url);

        const params = new URLSearchParams(urlObj.search);

        // look for utm_source, if it doesn't exist, add it
        if (!params.has("utm_source")) {
            params.append("utm_source", "xapp");
        }

        // now add the query string back to the url
        urlObj.search = params.toString();

        // and finally, update the url
        url = urlObj.toString();

    } catch (_) {
        // do nothing
    }

    const type = behavior.type;

    switch (type) {
        case "newWindow":
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            }
            window.open(url, "callout-option", `toolbar=0,status=0,width=${behavior.width || 1000},height=${behavior.height || 700}`);
            break;
        case "newTab":
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            }
            window.open(url, "_blank");
            break;
        case "sameWindow":
            if (!visuals.opened) {
                dispatch(setVisualStatus({
                    opened: true
                }));
            }
            window.open(url, "_self");
            break;
        default:
            throwBadKind(type);
    }
}

export function useOpenUrlCallback(): OpenUrlCallback {
    const env = useWidgetEnv();

    return useCallback<OpenUrlCallback>((url, dispatch, visuals, behavior) => {
        if (!behavior) {
            behavior = env?.urls ? resolveUrlPolicy(url, env.urls) : defaultBehavior;
        }
        execute(url, dispatch, visuals, behavior);
    }, [env]);
}
